'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import { ProductCard } from '../cards';
import LoadingProductCard from '../cards/loading-product-card';
import { Autoplay } from 'swiper/modules';
// import {
//   ProductListBreakpoints,
//   ProductListBreakpointsForCart,
// } from '@/constants/swiperBreakPoints.constants';
// import { Autoplay } from 'swiper/modules';

const ProductsSliders = ({
  children,
  fromCartPopUp,
  products = [],
  isLoading,
  setIsBeginning,
  setIsEnd,
  locale,
  set_swiper,
}) => {
  // if (!isLoading && !products.length) {
  //   return;
  // }
  return (
    <section>
      {children}
      <div className='mt-6 max-sm:mt-4'>
        <Swiper
          onInit={(e) => set_swiper && set_swiper(e)}
          dir={locale === 'en' ? 'ltr' : 'rtl'}
          // modules={[Autoplay]}
          // autoplay={{ delay: 2500, pauseOnMouseEnter: true }}
          // breakpoints={
          //   !fromCartPopUp
          //     ? ProductListBreakpoints
          //     : ProductListBreakpointsForCart
          // }
          slidesPerView={'auto'}
          breakpoints={{
            320: { spaceBetween: 10 },
            1024: { spaceBetween: 31 },
          }}
          onSlideChange={(swiper) => {
            setIsBeginning(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
          }}
          modules={[Autoplay]}
          autoplay={{ delay: 3000, pauseOnMouseEnter: true }}
        >
          {isLoading
            ? [...Array(5).keys()].map((i) => (
                <SwiperSlide
                  key={i}
                  className='max-w-[222px] min-w-[222px] max-lg:max-w-52 max-lg:min-w-52 max-md:max-w-44 max-md:min-w-44 max-sm:max-w-36 max-sm:min-w-36'
                >
                  <LoadingProductCard />
                </SwiperSlide>
              ))
            : products?.map((product, i) => (
                <SwiperSlide
                  key={i}
                  className='max-w-[222px] min-w-[222px] max-lg:max-w-52 max-lg:min-w-52 max-md:max-w-44 max-md:min-w-44 max-sm:max-w-36 max-sm:min-w-36'
                >
                  <ProductCard {...{ product, fromCartPopUp }} />
                </SwiperSlide>
              ))}
        </Swiper>
      </div>
    </section>
  );
};

export default ProductsSliders;
